// extracted by mini-css-extract-plugin
export var chip = "_65-9";
export var chipLabel = "_65-a";
export var close = "_65-7";
export var closeIcon = "_65-8";
export var error = "_65-6";
export var infoTooltip = "_65-2";
export var innerContainer = "_65-1";
export var input = "_65-b";
export var medium = "_65-5";
export var outerContainer = "_65-0";
export var small = "_65-4";
export var xSmall = "_65-3";